import './About.css'

function About() {
    return (
        <div className='container' id='sobreNos'>
            <div className='gTitles'>
                <h3 className="titles">About Us</h3>
                <p className="line"></p>
            </div>
            <div className='blocoContent' >
                <div className='blocoabout'>
                    <div>
                        <h2>
                            More then 10 years...
                        </h2>
                    </div>
                    <div>
                        <p>Bluebird specializes in post-production and localization services for the Film, TV, Streaming, and Games industries. Currently, it has studios in Rio de Janeiro and Florida, USA, creating lean and objective solutions for a wide range of audiovisual demands.
                        </p>
                    </div>
                </div>

            </div>
        </div>

    )
}

export default About;